import { useNavigate, useLocation } from 'react-router-dom';
import { ButtonBase, Tab, Tabs } from '@mui/material';
import SettingsNav from './SettingsNav';
import { APP_LABELS } from '../utils/labels';

export default function PageHeader() {
  const navigate = useNavigate();
  const location = useLocation();

  const activeTab =
    location.pathname === '/planning' ? 'planning' :
    location.pathname === '/' ? 'dashboard' :
    false;

  return (
    <header className="shrink-0 bg-surface border-b border-border">
      <div className="flex items-center gap-3 px-4 py-2">
        <ButtonBase onClick={() => navigate('/planning')} aria-label={APP_LABELS.navPlanning} className="rounded">
          <img src="/planly-logo-cropped.svg" alt={APP_LABELS.appName} className="h-9 w-auto md:hidden" />
          <img src="/planly-logo-light.svg" alt={APP_LABELS.appName} className="h-9 w-auto hidden md:block dark:hidden" />
          <img src="/planly-logo-dark.svg" alt={APP_LABELS.appName} className="h-9 w-auto hidden md:dark:block" />
        </ButtonBase>

        <nav aria-label={APP_LABELS.navPlanning} className="hidden lg:block self-stretch">
          <Tabs
            value={activeTab}
            onChange={(_, val: string) => navigate(val === 'dashboard' ? '/' : '/planning')}
            textColor="primary"
            indicatorColor="primary"
            sx={{ height: '100%', '& .MuiTabs-flexContainer': { height: '100%' } }}
          >
            <Tab value="dashboard" label={APP_LABELS.navDashboard} />
            <Tab value="planning" label={APP_LABELS.navPlanning} />
          </Tabs>
        </nav>

        <div className="ml-auto flex items-center gap-1">
          <SettingsNav />
        </div>
      </div>
    </header>
  );
}
